<template>
  <div class="webhook">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>Webhook <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
        </div>

        <ErrorAlert
          :error="error"
          class="mt-2" />
        <div
          v-if="successMessage"
          class="alert alert-success mt-2"
          role="alert">
          {{ successMessage }}
        </div>

        <div class="config-form mt-2">
          <div class="form-group row">
            <label
              for="webhookUrl"
              class="col-sm-4 col-form-label">URL do Webhook</label>
            <div class="col-sm-8">
              <input
                id="webhookUrl"
                type="text"
                class="form-control"
                v-model="webhookUrl">
            </div>
          </div>
          <div class="form-group row">
            <label
              for="webhookVersion"
              class="col-sm-4 col-form-label">Versão</label>
            <div class="col-sm-8">
              <select
                class="form-control custom-select custom-select-sm"
                v-model="webhookVersion">
                <option
                  v-for="option in versionOptions"
                  :key="option.value"
                  :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="webhookVersion"
              class="col-sm-4 col-form-label">Tipos de evento</label>
            <div class="col-sm-8">
              <select
                class="form-control custom-select custom-select-sm"
                v-model="webhookTypes">
                <option
                  v-for="option in typeOptions"
                  :key="option.key"
                  :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="text-right">
            <button
              v-if="activeIntegration"
              type="button"
              class="btn btn-outline-danger mr-2"
              @click.prevent="deleteIntegration">Desativar</button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!configReady"
              @click.prevent="saveIntegration">{{ labelSubmit }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'

export default {
  name: 'IntegrationWebhook',
  data () {
    return {
      error: null,
      successMessage: null,
      integration: null,
      configReady: false,
      webhookUrl: null,
      webhookVersion: 'v1.4',
      webhookTypes: ['channel-hangup', 'channel-answer'],
      versionOptions: [
        { value: 'v1.4', text: 'v1.4 (Padrão)' },
        { value: 'v1.8', text: 'v1.8 (Padrão E.164)' }
      ],
      typeOptions: [
        { key: 'all', value: ['channel-hangup', 'channel-answer'], text: 'Todos' },
        { key: 'channel-hangup', value: ['channel-hangup'], text: 'Após desligamento da chamada' },
        { key: 'channel-answer', value: ['channel-answer'], text: 'Após atendimento da chamada' }
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return loopback
        .get(`/integrations?filter[where][gateway]=webhook`)
        .then(integrations => {
          this.integration = integrations.pop()
          if (this.integration && this.integration.metadata) {
            this.webhookUrl = this.integration.metadata.webhookUrl
            this.webhookVersion = this.integration.metadata.webhookVersion
            this.webhookTypes = this.integration.metadata.webhookTypes
            this.configReady = true
          }
        })
        .catch(err => { this.$emit('onError', err) })
    },
    saveIntegration () {
      if (this.webhookUrl) {
        this.error = null
        const integrationParams = {
          gateway: 'webhook',
          webhook: true,
          metadata: {
            webhookUrl: this.webhookUrl,
            webhookVersion: this.webhookVersion,
            webhookTypes: this.webhookTypes
          }
        }
        if (this.integration) integrationParams.id = this.integration.id
        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            this.showSuccess('Integração de Webhook atualizada com sucesso!')
          })
          .catch(err => {
            this.error = err
            // TEL-2243: o `friendly` do interceptor ja resolve `details.messages` pelo
            // FIELD_MESSAGES, mantem em pt-BR o que o backend ja manda traduzido e nomeia
            // o campo quando nao ha texto proprio. Montar `lines` aqui devolvia o texto do
            // LoopBack em ingles e ainda sobrescrevia a traducao.
          })
      } else {
        this.error = {
          message: 'URL do Webhook é obrigatório'
        }
      }
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.webhookUrl = null
          this.error = null
          this.configReady = false
          this.showSuccess('Integração de Webhook removida com sucesso!')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    isValidWebhookUrl () {
      let url
      try {
        url = new URL(this.webhookUrl)
      } catch (_) {
        return false
      }
      return url.protocol === 'http:' || url.protocol === 'https:'
    },
    showSuccess (message) {
      this.successMessage = message
      if (this._successTimer) clearTimeout(this._successTimer)
      this._successTimer = setTimeout(() => { this.successMessage = null }, 4000)
    }
  },
  computed: {
    activeIntegration () {
      return this.integration && this.integration.gateway === 'webhook'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    }
  },
  watch: {
    webhookUrl: function () {
      this.configReady = this.isValidWebhookUrl()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/Webhook.vue